import { configureStore } from "@reduxjs/toolkit"
import authSlice from "./authSlice"
import dateSlice from "./dateSlice"
import serviceSlice from "./serviceSlice"
import userReducer from "./userSlice"
import clientSlice from "./clientSlice"
import languageSlice from "./languageSlice"
import companySlice from "./companySlice"

export default configureStore({
  reducer: {
    user: userReducer,
    client: clientSlice,
    auth: authSlice,
    date: dateSlice,
    service: serviceSlice,
    lang: languageSlice,
    company: companySlice,
  },
})
